// extracted by mini-css-extract-plugin
module.exports = {"container":"participants_container__3demm","userIcon":"participants_userIcon__2A9F7"};